import { DefaultTheme, Icon, IconsProps, Title, TitleProps } from "@deliverr/ui";
import { useRouter } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React, { ButtonHTMLAttributes } from "react";
import { useIntl } from "react-intl";
import { useRecoilValue } from "recoil";
import { isMobile } from "sortation/base/isMobile";
import { sortationIdState } from "sortation/base/sortationIdState";
import { SortationPath } from "sortation/base/sortationPath";
import { BrowserPrinterSelect } from "sortation/components/BrowserPrinterSelect/BrowserPrinterSelect";
import { PrinterSelect } from "sortation/components/PrinterSelect";
import { QUINCE_GAYLORD_SORTATION_CENTERS } from "sortation/pages/Outbound/quinceGaylordSortationCenters";

const LabelPrinterContainer = styled.div<Record<string, unknown>, DefaultTheme>(
  ({ theme }) => `
    margin: ${theme.spacing.S4};
  `
);

const PrinterSelectContainer = styled.div<Record<string, unknown>, DefaultTheme>(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.S5};
`
);

const StyledTitle = styled(Title)<TitleProps, DefaultTheme>(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.S3};
`
);

const LabelTypes = styled.div<Record<string, unknown>, DefaultTheme>(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    background: ${theme.colors.NEUTRAL["00"]};
    box-shadow: ${theme.shadow.S2};
    border-radius: ${theme.border.radius.R5};
  `
);

const LabelType = styled.button<Record<string, unknown>, DefaultTheme>(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing.S5};
    color: ${theme.colors.NEUTRAL["500"]};
    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.NEUTRAL["60"]};
    }
  `
);

const LabelTypeIcon = styled(Icon)<IconsProps, DefaultTheme>(
  ({ theme }) => `
color: ${theme.colors.NEUTRAL["300"]};
`
);

const LabelPrintButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...props }) => (
  <LabelType {...props}>
    {children}
    <LabelTypeIcon type="chevron-right" />
  </LabelType>
);

export const ZebraLabelPrint = () => {
  const router = useRouter();
  const { formatMessage } = useIntl();
  const sortationId = useRecoilValue(sortationIdState);
  const isQuinceSortationCenter = QUINCE_GAYLORD_SORTATION_CENTERS.includes(sortationId ?? "");

  return (
    <LabelPrinterContainer>
      <PrinterSelectContainer>{isMobile ? <PrinterSelect /> : <BrowserPrinterSelect />}</PrinterSelectContainer>
      <StyledTitle displayAs="h4" as="h2">
        {formatMessage({ id: "sortation.labelprint.title", defaultMessage: "Select label type" })}
      </StyledTitle>
      <LabelTypes>
        <LabelPrintButton onClick={() => router.push(SortationPath.GAYLORD_LABEL)}>
          {formatMessage({ id: "sortation.labelprint.gaylordLabelBtn", defaultMessage: "Gaylord label" })}
        </LabelPrintButton>
        {isQuinceSortationCenter && (
          <LabelPrintButton onClick={() => router.push(SortationPath.MASTER_CARTON_LABEL)}>
            {formatMessage({ id: "sortation.labelprint.masterCartonLabelBtn", defaultMessage: "Master carton label" })}
          </LabelPrintButton>
        )}
        <LabelPrintButton onClick={() => router.push(SortationPath.SHIPPING_LABEL)}>
          {formatMessage({ id: "sortation.labelprint.shippingLabelBtn", defaultMessage: "Shipping label" })}
        </LabelPrintButton>
        <LabelPrintButton onClick={() => router.push(SortationPath.DOCK_DOOR_LABEL)}>
          {formatMessage({ id: "sortation.labelprint.dockDoorLabelBtn", defaultMessage: "Dock door label" })}
        </LabelPrintButton>
        <LabelPrintButton onClick={() => router.push(SortationPath.SHIP_TO_STORE_LABEL)}>
          {formatMessage({ id: "sortation.labelprint.shipToStoreLabelBtn", defaultMessage: "Ship to store label" })}
        </LabelPrintButton>
      </LabelTypes>
    </LabelPrinterContainer>
  );
};
